// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import dealers from './dealers';
import division from './division';
import hasSearchRun from './has-search-run';
import searchParams from './dealer-search-params';

export default {
    productDealerSearch: combineReducers({
        busyCounter,
        dealers,
        division,
        hasSearchRun,
        searchParams
    })
};



// WEBPACK FOOTER //
// ./src/product/dealer-search/reducers/index.js